import "./App.css";
import Layout from "./components/layout/Layout";

import { ThemeProvider, useTheme } from "./ThemeContext";
import { UserRoleProvider } from "./context/UserRoleContext";
import ZoomableWrapper from "./components/common/ZoomWraper";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";

// import { GoogleOAuthProvider } from "@react-oauth/google";
import { Helmet } from "react-helmet";
// import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";
import { syncVault } from "./utils/CustomerUiAPI";
import { decryptData } from "./utils/utility-functions";
import { useLocation } from "react-router-dom";

function App() {
  const [clientConfig, setClientConfig] = useState(null);
  const location = useLocation();

  const decryptConfig = async (enc) => {
    const dec = await decryptData(enc);
    return dec.data;
  };

  const loadOrFetchConfigs = async () => {
    if (!sessionStorage.getItem("config")) fetchClientConfigs();

    const enc = sessionStorage.getItem("config");
    const dec = await decryptConfig(JSON.parse(enc));
    setClientConfig(dec);
  };

  const fetchClientConfigs = async () => {
    try {
      const encryptedConfig = await syncVault();
      console.log(encryptedConfig.data, "encryptedConfig");
      const decryptedConfig = await decryptConfig(encryptedConfig.data);
      setClientConfig(decryptedConfig);
      sessionStorage.setItem("config", JSON.stringify(encryptedConfig.data));
    } catch (error) {
      console.error("Error fetching client configuration:", error);
    }
  };

  useEffect(() => {
    if (
      location.pathname === "/home" &&
      sessionStorage.getItem("BasicToken") &&
      !clientConfig
    ) {
      loadOrFetchConfigs();
    }
  }, [location]);

  if (
    process.env.REACT_APP_APP_MODE === "PRODUCTION" &&
    window.location.protocol === "http:"
  ) {
    try {
      window.location.replace(
        "https://" + window.location.host + window.location.pathname
      );
    } catch (error) {
      console.error("Failed to redirect to HTTPS:", error);
    }
  }

  // const googleClientId = clientConfig?.googleOAuthClientId || "";
  // const stripeKey = clientConfig?.stripeKey || "";
  // const stripePromise = stripeKey ? loadStripe(stripeKey) : null;

  const API_BASE_URL =
    process.env.REACT_APP_API_GATEWAY_URL ??
    process.env.REACT_APP_BACKEND_URL_DEV;
  const GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;
  const isDevelopment = process.env.NODE_ENV === "development";
  const devConnectSrc = "http://127.0.0.1:8080 http://localhost:8080 http://localhost:3001 http://127.0.0.1:3001";
  const commonConnectSrc = [
    "'self'",
    "blob:",
    "https://identitytoolkit.googleapis.com",
    "https://accounts.google.com/gsi/client",
    "https://js.stripe.com",
    "https://securetoken.googleapis.com/v1/token",
    "https://storage.googleapis.com",
    "https://storage.cloud.google.com",
    "https://unpkg.com",
    "https://maps.googleapis.com",
    "https://*.googleapis.com",
    API_BASE_URL,
    GATEWAY_URL,
    "https://dev-customer-ui-803797777586.us-central1.run.app",
    "https://qa-customer-ui-894714350548.us-central1.run.app", 
    "https://prod-customer-ui-907496619557.us-central1.run.app",
    "https://customer.voicecare.ai",
    "https://devkong.voicecare.ai",
    "https://devkong.voicecare.ai/customer-ui-auth/",
    "https://devkong.voicecare.ai/customer-ui-ms/",
    "https://qakong.voicecare.ai",
    "https://qakong.voicecare.ai/customer-ui-auth/",
    "https://qakong.voicecare.ai/customer-ui-ms/",
    "https://34.54.79.89.nip.io/customer-ui-ms",
    "https://34.54.79.89.nip.io/",
    "https://34.49.73.143.nip.io/customer-ui-ms/",
    "https://34.49.73.143.nip.io/",
    "https://*.sentry.io",
    "https://docuseal.com",
    "https://*.docuseal.com",
    "https://api.docuseal.co",
    "https://docuseal.s3.amazonaws.com",
    "https://*.docuseal.s3.amazonaws.com",
    "http://localhost:8080",
    "http://127.0.0.1:8080",
    "https://cdn.redocly.com",
    "https://*.redocly.com",
    "https://qakong.voicecare.ai/",
  ];

  console.log(API_BASE_URL, "API_BASE_URL");

  const connectSrc = `connect-src ${commonConnectSrc.join(" ")} ${
    isDevelopment ? devConnectSrc : "http://localhost:8080 http://127.0.0.1:8080"
  };`;

  // Debug CSP
  console.log('CSP connect-src:', connectSrc);
  console.log('isDevelopment:', isDevelopment);
  console.log('devConnectSrc:', devConnectSrc);

  // CSP Notes:
  // - 'frame-ancestors' and 'report-uri' only work via HTTP headers, not <meta> tags (CSP spec)
  // - If you need these directives, configure them in your server/nginx headers
  // - 'require-trusted-types-for' removed as a quick fix
  return (
    // <GoogleOAuthProvider clientId={googleClientId}>
    <ZoomableWrapper>
      {/* <Elements stripe={stripePromise}> */}
      <Helmet>
        <meta
          http-equiv="Content-Security-Policy"
          content={`
                default-src 'self';
                script-src 'self' 'unsafe-inline' 'unsafe-eval' https://cdn.jsdelivr.net https://unpkg.com https://api.stripe.com https://apis.google.com https://maps.googleapis.com https://*.googleapis.com https://cdn.docuseal.com https://api.docuseal.co https://docuseal.com https://*.docuseal.com https://cdn.redocly.com https://*.redocly.com;
                style-src 'self' 'unsafe-inline' https://cdn.fontshare.com https://api.fontshare.com https://*.fontshare.com https://fonts.googleapis.com https://docuseal.com https://*.docuseal.com https://cdn.redocly.com https://*.redocly.com https://fonts.redoc.ly;
                img-src 'self' data: https: https://purecatamphetamine.github.io https://maps.googleapis.com https://maps.gstatic.com https://*.googleapis.com https://*.gstatic.com https://docuseal.s3.amazonaws.com https://*.docuseal.s3.amazonaws.com https://docuseal.com https://*.docuseal.com;
                font-src 'self' https://cdn.fontshare.com https://fonts.gstatic.com https://docuseal.com https://*.docuseal.com https://fonts.redoc.ly https://*.redocly.com;
                worker-src 'self' blob:;
                ${connectSrc}
                frame-src 'self' https://js.stripe.com https://docuseal.com https://*.docuseal.com https://storage.googleapis.com https://storage.cloud.google.com https://docs.google.com; 
                form-action 'self' https://docuseal.com https://*.docuseal.com;
                base-uri 'self';
                object-src 'none';
                media-src 'self' https://storage.googleapis.com https://storage.cloud.google.com https://docuseal.s3.amazonaws.com https://*.docuseal.s3.amazonaws.com;
                upgrade-insecure-requests;
            `}
        />
        <meta http-equiv="X-Content-Type-Options" content="nosniff" />
        <meta name="referrer" content="no-referrer" />
        <meta
          http-equiv="Strict-Transport-Security"
          content="max-age=31536000; includeSubDomains"
        />
        <meta http-equiv="X-XSS-Protection" content="1; mode=block" />
      </Helmet>
      <div className="App">
        <ThemeProvider>
          <ThemeBackgroundWrapper>
            <UserRoleProvider>
              <Layout />
            </UserRoleProvider>
          </ThemeBackgroundWrapper>
        </ThemeProvider>
      </div>
      {/* </Elements> */}
    </ZoomableWrapper>
    // </GoogleOAuthProvider>
  );
}

// Helper component to set background color dynamically
function ThemeBackgroundWrapper({ children }) {
  const { currentTheme } = useTheme();
  return (
    <div
      style={{
        backgroundColor: currentTheme.callhistory.mainBackground,
        minHeight: "100vh",
        width: "100vw",
      }}
    >
      {children}
    </div>
  );
}

// export default Sentry.withProfiler(App);
export default App;
